const API_HOST = process.env.REACT_APP_API_HOST;

export const JODI_REPORT_ENDPOINTS = {
  digits: "/jodi-report/digits",
  users: "/jodi-report/users",
  bets: "/jodi-report/bets",
};

export const fetchJodiReportPage = async (endpoint, payload) => {
  const response = await fetch(`${API_HOST}${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("jwt"),
    },
    body: JSON.stringify(payload),
  });

  if (response.status === 401) {
    throw new Error("Unauthorized");
  }

  const result = await response.json();
  if (!result?.success) {
    throw new Error(result?.message || "Failed to fetch report data");
  }

  return result.data;
};

export const createJodiReportDatasource = ({
  endpoint,
  getBasePayload,
  getSearch,
  onMeta,
}) => ({
  getRows: async (params) => {
    try {
      const pageSize = params.endRow - params.startRow;
      const page = Math.floor(params.startRow / pageSize) + 1;
      const sortModel = params.sortModel?.[0];

      const data = await fetchJodiReportPage(endpoint, {
        ...getBasePayload(),
        page,
        pageSize,
        search: getSearch?.() || "",
        sortField: sortModel?.colId || "",
        sortOrder: sortModel?.sort || "asc",
      });

      onMeta?.(data);
      params.successCallback(data.rows || [], data.pagination?.totalRows ?? 0);
    } catch (error) {
      console.error("Jodi report datasource error:", error);
      params.failCallback();
    }
  },
});

export const slNoColumn = {
  headerName: "Sl.No",
  valueGetter: (params) =>
    params.node?.rowIndex != null ? params.node.rowIndex + 1 : "",
  maxWidth: 80,
  sortable: false,
};

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/** Formats match draw_date as e.g. 30-July-2026 */
export const formatDrawDate = (drawDate) => {
  if (!drawDate) return "";

  let year;
  let month;
  let day;

  if (drawDate instanceof Date && !isNaN(drawDate.getTime())) {
    year = drawDate.getFullYear();
    month = drawDate.getMonth() + 1;
    day = drawDate.getDate();
  } else {
    const value = String(drawDate).trim();
    // YYYY-MM-DD or ISO datetime
    const isoMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    // DD-MM-YYYY
    const dmyMatch = value.match(/^(\d{2})-(\d{2})-(\d{4})/);

    if (isoMatch) {
      year = parseInt(isoMatch[1], 10);
      month = parseInt(isoMatch[2], 10);
      day = parseInt(isoMatch[3], 10);
    } else if (dmyMatch) {
      day = parseInt(dmyMatch[1], 10);
      month = parseInt(dmyMatch[2], 10);
      year = parseInt(dmyMatch[3], 10);
    } else {
      const parsed = new Date(value);
      if (isNaN(parsed.getTime())) return value;
      year = parsed.getFullYear();
      month = parsed.getMonth() + 1;
      day = parsed.getDate();
    }
  }

  const monthName = MONTH_NAMES[month - 1];
  if (!monthName || !year || !day) return String(drawDate);

  return `${String(day).padStart(2, "0")}-${monthName}-${year}`;
};
